import React, { useEffect, useRef } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import './BrandSportNav.css';

function BrandSportNav({ sports, brandSlug }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const scrollRef = useRef(null);
  const { brandSlug: routeSlug } = useParams();
  const slug = brandSlug || routeSlug || '';
  const sportSlug = searchParams.get('sport') || '';

  useEffect(() => {
    const active = scrollRef.current?.querySelector('.brand-sport-nav-pill.active');
    if (!active) return undefined;
    const id = window.requestAnimationFrame(() => {
      active.scrollIntoView({
        inline: 'center',
        block: 'nearest',
        behavior: 'smooth',
      });
    });
    return () => window.cancelAnimationFrame(id);
  }, [sportSlug, sports]);

  if (!slug || !sports?.length) {
    return null;
  }

  const base = `/brands/${slug}`;

  const navigateToSport = nextSportSlug => {
    if (!nextSportSlug || nextSportSlug === sportSlug) {
      navigate(base);
      return;
    }
    navigate(`${base}?sport=${nextSportSlug}`);
  };

  return (
    <nav className="brand-sport-nav" aria-label="Brand sports">
      <div className="brand-sport-nav-scroll" ref={scrollRef}>
        <button
          type="button"
          className={`brand-sport-nav-pill${!sportSlug ? ' active' : ''}`}
          onClick={() => navigate(base)}
        >
          All sports
        </button>
        {sports.map(sport => (
          <button
            key={sport.slug}
            type="button"
            className={`brand-sport-nav-pill${sportSlug === sport.slug ? ' active' : ''}`}
            onClick={() => navigateToSport(sport.slug)}
          >
            {sport.name}
          </button>
        ))}
      </div>
    </nav>
  );
}

export default BrandSportNav;
